<template>
  <b-navbar :fixed-top="true" class="is-primary">
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img
          src="@/assets/logo.png"
          alt="Sistema de gestion de la seguridad y salud en el trabajo"
        />
      </b-navbar-item>
    </template>
    <template #start>
      <b-navbar-item href="/"> Inicio </b-navbar-item>
      <b-navbar-dropdown label="Información">
        <router-link to="/about">
          <b-navbar-item> Acerca de </b-navbar-item></router-link
        >
        <router-link to="/config">
          <b-navbar-item> Configuración </b-navbar-item></router-link
        >
      </b-navbar-dropdown>
    </template>

    <template #end>
      <b-navbar-item tag="div">
        <div class="buttons">
          <a class="button is-primary">
            <strong>Registrarse</strong>
          </a>
          <a class="button is-light">Ingresar </a>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>
<script>
export default {
  name: "DashboardCoreAppBar",
};
</script>
